import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { translations } from "../../../utils/translations.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  gap: 2rem;
  text-align: center;
  height: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 500px;
`;

const Title = styled.h1`
  color: var(--secondary-font-color);
  font-weight: bold;
  font-size: 5rem;
  font-family: Georgia, serif;
  text-shadow: 6px 6px 4px var(--tertiary-green);

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const Message = styled.p`
  color: var(--secondary-font-color);
  font-size: 1.5rem;
  font-family: Georgia, serif;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 2rem;
  width: 100%;
`;
const Button = styled(Link)`
  flex: 1;
  background-color: ${(props) =>
    props.$isNegative ? "white" : "var(--tertiary-green)"};
  opacity: 0.85;
  color: ${(props) => (!props.$isNegative ? "white" : "var(--tertiary-green)")};
  box-shadow: 6px 6px 30px var(--tertiary-green);
  font-weight: bold;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 1.2rem;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  margin-top: 1rem;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
      props.$isNegative ? "rgb(1,1,1,0.05)" : "var(--tertiary-green)"};
    opacity: 1;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 10px 20px;
  }
`;

const Image = styled.img`
  height: auto;
  width: 40%;
  max-width: 500px;
`;

const NoPageError = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);

  return (
    <Wrapper data-testid="no-page-error">
      <Image src="/images/castleprinter.png" alt="404" />

      <TextWrapper>
        <Title>Oops!</Title>
        <Message>
          {translations[languageCode]["error-404-page-message"]}
        </Message>
        <ButtonWrapper>
          <Button to={`/`}>Home</Button>
          <Button $isNegative to={`/support`}>
            Contact
          </Button>
        </ButtonWrapper>
      </TextWrapper>
    </Wrapper>
  );
};

export default NoPageError;
